<template>
	<div class="home">
		<div class="header_top">
			<div class="nex_topgt">
				<div class="w1180">
					<div class="nex_topgtbd">
						<div class="nex_topbd_l">
							<ul>
								<li class="nex_top_phone">+86 15942806613 </li>
								<li class="nex_top_email">moolsnet@126.com</li>
								<li class="nex_top_adds">大连市高新园区 广贤路57号</li>
							</ul>
						</div>
						<div class="nex_topbd_r">

							<!-- <div class="nex_top_app">
							<span>手机版</span>
							<div class="nex_top_but">
								<i></i>
								<h5>扫码访问手机版</h5>
								<img src="template/zvis_enterprise_180102/neoconex/top/ewm.jpg">
							</div>
						</div> -->
							<div class="nex_top_wx">
								<span>关注微信</span>
								<div class="nex_top_but">
									<i></i>
									<h5>扫码关注官方微信</h5>
									<img src="http://www.mools.net/HTML/assets/img/qrcode.jpg">
								</div>
							</div>

							<div class="clear"></div>
						</div>
						<div class="clear"></div>
					</div>
				</div>
			</div>
			<div id="nexheader" class="nexheader">
				<div class="w1180">
					<div class="nexlogo">
						<h2>
							<img class="logoc2" src="https://www.mools.net/lims/web/OfficialWebsite/images/logo1.png" border="0">

							<a href="./" title="Discuz! Board" style="    position: relative;
    top: -38px;
    left: 38px;">
								<img class="logoc" src="https://www.mools.net/lims/web/OfficialWebsite/images/logo2.png" border="0"></a></h2>
					</div>
					<div class="nexnav">
						<ul>
						<li @click="menhu(index)" v-for="(item,index) in listLeft" :class="{'a':curyes==index}" > <a >{{item}}</a>  </li>

						</ul>
					</div>

					<div class="clear"></div>
				</div>
			</div>
		</div>













		<div>
			<router-view @info="info"></router-view>

		</div>
	<div class="nexftbottom">
        	<div class="w1180">
                <!-- <p>Copyright © 2019 Mools.net All Rights Reserved | 辽ICP备17015248号-1</p> -->
                <p>Copyright © 2020 Mools.net All Rights Reserved | <a target="_blank" href="http://beian.miit.gov.cn">辽ICP备17015248号-1</a> </p>
                <!-- © 2009-2020 Aliyun.com 版权所有 增值电信业务经营许可证：浙B2-20080101 -->
            </div>
        </div>
		<Cebianlan></Cebianlan>
	</div>
</template>

<script>
		import Cebianlan from '../views/cebianlan/cebianlan.vue'

	export default {
		name: 'home',
		components: {

			Cebianlan
		},
		data() {
			return {
				curyes:0,
				listLeft:[
					"门户",
						"产品案例",
							"关于我们",
              "登录"
				],
				active:1,
				login_show: false, //是否显示登录注册内容
				dialog_item: 'login', //默认登录
				formLabel: {
					userName: '',
					email: '',
					password: '',
					repeatPassword: '',
					agree: '',
					remember: ''
				},
				show_item: false, //课程与学院下拉列表显示
			}
		},
		methods: {
			opt: function(str) {
				this.login_show = true
				this.dialog_item = str
			},
			goHome: function() {
				this.$router.push("/")
			},
			info: function(message) {
				if (message == 'regist') {
					this.login_show = true
					this.dialog_item = message
				}
			},
			showItem: function() {
				this.show_item = !this.show_item;
			},
			outItem: function() {
				this.show_item = false;
			},
			aboutOur(){
				this.active =3;
				this.$router.push('/home/about')
			},
			community: function() {
				this.active =2;
				this.$router.push('/home/community')
			},
			menhu(index){

				this.curyes = index;
				switch (index){
					case 0:
					this.$router.push('/home/index')
				break;
					case 1:
					this.$router.push('/home/community')
				break;
					case 2:
					this.$router.push('/home/about/companyProfile')
          window.sessionStorage.setItem("curyes", 0);
				break;
	        case 3:

          window.location.href = "https://www.mools.net/lims/api/laravel/public/index.php/toPcLogin"
					// this.$router.push('/home/about')
				break;

				}
				this.active =1;
				// this.$router.push('/home/index')

			},
			goRouter: function(url) {
				this.$router.push(url)
			},
			handleClose(done) {
				// 						this.$confirm('确认关闭？').then(_ => {
				//             done();
				//           })
				//           .catch(_ => {});
			},
			handleScroll() { //改变元素#searchBar的top值
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
				// var offsetTop = document.querySelector('.home-div').offsetTop;
				if (scrollTop > 1) {
					// document.querySelector('.home-div').style.background = "#000";
					// document.querySelector('.home-div').style.opacity = 0.5;
					document.querySelector('.nex_topgt').style.display = "none";

					// alert(111)
					document.getElementById("nexheader").classList.add("nex_subtops");


				} else {
					document.getElementById("nexheader").classList.remove("nex_subtops");
					// document.querySelector('.home-div').style.background = "unset"
					document.querySelector('.nex_topgt').style.display = "block";
				}
			},
		},
		mounted() { //给window添加一个滚动滚动监听事件
			window.addEventListener('scroll', this.handleScroll)
		},
		destroyed() { //离开该页面需要移除这个监听的事件
			window.removeEventListener('scroll', this.handleScroll)
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.logoc{
  width: 153px;
  height: 38px;
}
.logoc2{
  width: 38;
  height: 38px;
}
	.nexftbottom p {
    height: 40px;
    line-height: 40px;
}
	.nexftbottom p, .nexftbottom a {
    font-size: 12px;
    color: #848586;
}
	.nexftbottom {
    padding: 12px 0;
    width: 100%;
    min-width: 1180px;
    background: #1c1c1c;
    text-align: center;
}
	.nexnav ul li.a a:after {
		width: 100%;
		filter: alpha(opacity=100);
		-ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
		-webkit-opacity: 1;
		-khtml-opacity: 1;
		-moz-opacity: 1;
		-ms-opacity: 1;
		-o-opacity: 1;
		opacity: 1;
		-webkit-transition: all 300ms linear 0ms;
		-khtml-transition: all 300ms linear 0ms;
		-moz-transition: all 300ms linear 0ms;
		-ms-transition: all 300ms linear 0ms;
		-o-transition: all 300ms linear 0ms;
		transition: all 300ms linear 0ms;
	}

	.nexnav ul li a:after {
		background-color: #fff;
		content: "";
		height: 1px;
		position: absolute;
		left: 0;
		top: 0px;
		width: 0;
		filter: alpha(opacity=0);
		-ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
		-webkit-opacity: 0;
		-khtml-opacity: 0;
		-moz-opacity: 0;
		-ms-opacity: 0;
		-o-opacity: 0;
		opacity: 0;
		-webkit-transition: all 300ms linear 0ms;
		-khtml-transition: all 300ms linear 0ms;
		-moz-transition: all 300ms linear 0ms;
		-ms-transition: all 300ms linear 0ms;
		-o-transition: all 300ms linear 0ms;
		transition: all 300ms linear 0ms;
	}

	.nexnav ul li.a a {
		color: #fff;

	}

	.nex_subtops {
		border-bottom: 0 !important;
		padding: 3px 0 !important;
		position: fixed;
		top: 0px;
		width: 100%;
		z-index: 150;
		left: 0px;
		margin-top: 0px;
		padding: 0px;
		background: rgba(0, 0, 0, 0.7);
		min-width: 1180px;
		height: 60px;
		transition: all 0.3s linear;
	}


	.header_top {
		position: fixed;
		z-index: 999;
		width: 100%;
	}


	.nex_topgt {
		width: 100%;
		min-width: 1180px;
		position: relative;

		z-index: 102;
		border-bottom: 1px solid rgba(255, 255, 255, 0.20);
	}

	.w1180 {
		width: 1180px;
		margin: 0 auto;
	}

	.nex_topgtbd {
		height: 45px;
		line-height: 45px;
	}

	.nex_topbd_l {
		float: left;
		height: 45px;
		line-height: 45px;
	}

	.nex_topbd_l ul li.nex_top_phone {
		background: url(http://xdqy.lcwluo.top/template/zvis_enterprise_180102/neoconex/top/tel.png) left center no-repeat;
	}

	.nex_topbd_l ul li.nex_top_email {
		background: url(http://xdqy.lcwluo.top/template/zvis_enterprise_180102/neoconex/top/email.png) left center no-repeat;
		margin-left: 15px;
	}

	.nex_topbd_l ul li.nex_top_adds {
		background: url(http://xdqy.lcwluo.top/template/zvis_enterprise_180102/neoconex/top/address.png) left center no-repeat;
		padding-left: 19px;
		margin-left: 15px;
		border-right: 0;
	}

	.nex_topbd_l ul li {
		float: left;
		padding-right: 15px;
		border-right: 1px solid rgba(255, 255, 255, 0.20);
		font-size: 12px;
		color: #ddd;
		padding-left: 25px;
		height: 15px;
		line-height: 15px;
		margin-top: 15px;
	}

	.nex_topbd_r {
		float: right;
		height: 45px;
	}

	.nex_top_app {
		float: left;
		height: 45px;
		line-height: 45px;
		margin-right: 15px;
		position: relative;
		z-index: 101;
		cursor: pointer;
	}

	.nex_top_but {
		padding: 15px;
		background: #fff;
		width: 100px;
		position: absolute;
		top: 45px;
		left: 0;
		z-index: 101;
		display: none;
	}

	.nex_top_but i {
		display: block;
		width: 10px;
		height: 5px;
		background: url(http://xdqy.lcwluo.top/template/zvis_enterprise_180102/neoconex/top/toptrs.png) no-repeat;
		position: absolute;
		top: -4px;
		left: 20px;
	}

	.nex_top_but h5 {
		line-height: 25px;
		text-align: center;
		overflow: hidden;
		font-size: 12px;
		color: #434343;
		font-weight: 300;
	}

	.nex_top_but img {
		width: 100px;
		height: 100px;
		display: block;
		margin: 10px auto 0;
	}

	.nex_top_wx {
		float: left;
		height: 15px;
		line-height: 15px;
		position: relative;
		cursor: pointer;
	}

	.nex_top_wx span {
		display: block;
		height: 15px;
		line-height: 15px;
		margin-top: 15px;
		font-size: 12px;
		color: #ddd;
		padding-left: 20px;
		background: url(http://xdqy.lcwluo.top/template/zvis_enterprise_180102/neoconex/top/wx.png) left center no-repeat;
	}

	.nex_top_but i {
		display: block;
		width: 10px;
		height: 5px;
		background: url(http://xdqy.lcwluo.top/template/zvis_enterprise_180102/neoconex/top/toptrs.png) no-repeat;
		position: absolute;
		top: -4px;
		left: 20px;
	}

	.nex_top_but h5 {
		line-height: 25px;
		text-align: center;
		overflow: hidden;
		font-size: 12px;
		color: #434343;
		font-weight: 300;
	}

	.nex_top_but img {
		width: 100px;
		height: 100px;
		display: block;
		margin: 10px auto 0;
	}

	.clear {
		clear: both;
	}

	.nex_top_wx:hover .nex_top_but {
		display: block;
	}



	.nex_top_app span {
		display: block;
		height: 45px;
		line-height: 45px;
		font-size: 12px;
		color: #ddd;
		padding-left: 20px;
		background: url(http://xdqy.lcwluo.top/template/zvis_enterprise_180102/neoconex/top/cell.png) left center no-repeat;
	}

	#nexheader {
		/* background: none; */
		border-bottom: 1px solid rgba(255, 255, 255, 0.20);
	}

	.w1180 {
		width: 1180px;
		margin: 0 auto;
	}

	.nexlogo {
		float: left;
		width: 160px;
		height: 30px;
		margin-top: 15px;
	}

	#hd h2 {
		padding: 0 20px 8px 0;
		float: left;
	}

	.nexnav {
		width: 700px;
		height: 60px;
		float: left;
		margin-left: 100px;
		overflow: hidden;
	}

	.nexnav ul li {
		float: left;
		cursor: pointer;
	}

	.nexnav ul li a {
		display: inline-block;
		margin-right: 30px;
		height: 60px;
		line-height: 60px;
		letter-spacing: 1px;
		color: #ccc;
		font-size: 14px;
		text-align: center;
		position: relative;
		font-weight: 400;
	}

</style>



// WEBPACK FOOTER //
// src/components/home.vue